import { getTypedStepValues } from "features/contracting/helpers/contractingFormHelper";
import ContractingStepSummaryProps from "features/contracting/models/ContractingStepSummaryProps";
import CustomerTypeStep from "features/contracting/models/steps/customerType/CustomerTypeStep";
import PageCard from "features/shared/components/card/PageCard";
import CheckValueInfoItem from "features/shared/components/infoItem/CheckValueInfoItem";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";
import React from "react";
import { useTranslation } from "react-i18next";

const CustomerTypeSummary = ({
  contracting,
  step,
}: ContractingStepSummaryProps) => {
  // translations
  const tCustomerTypes = useTranslation(
    "customer\\enums\\customerType"
  ).t;
  const tCommodities = useTranslation("shared\\enums\\commodity").t;
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "customerTypeSummary");

  // private props
  const values = getTypedStepValues<CustomerTypeStep>(
    contracting,
    step.component
  );

  // render
  return (
    <PageCard title={tLabels("cardTitle")} bodyClassName="px-4 py-3">
      <CheckValueInfoItem
        title={tLabels("customerType")}
        value={values.customerType}
        formatValue={tCustomerTypes}
      />
      <CheckValueInfoItem
        title={tLabels("commodity")}
        value={values.commodity}
        formatValue={tCommodities}
      />
    </PageCard>
  );
};

export default CustomerTypeSummary;
